import { render, staticRenderFns } from "./topHeaderVip.vue?vue&type=template&id=6621429b&"
import script from "./topHeaderVip.vue?vue&type=script&lang=js&"
export * from "./topHeaderVip.vue?vue&type=script&lang=js&"
import style0 from "./topHeaderVip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports